import { useQuery } from '@apollo/react-hooks';
import { PageMetaContext } from '../context/PageMetaContext';
import { useNotNullableContext } from './useNotNullableContext';
import { QueryResult } from '@apollo/react-common';
import { BasePageDataQuery } from '../../types/__generated__';
import basePage from '../server/basePage.gql';

export default function useBasePageQuery(): QueryResult<BasePageDataQuery> {
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );
  const result = useQuery<BasePageDataQuery>(basePage, {
    variables: {
      type: pageType.toUpperCase(),
      slug: pageShortName,
      preview: isPreview,
      includeEvent: pageType.toUpperCase() === 'FUNDRAISING',
    },
    ssr: true,
  });
  return result;
}
